export default __webpack_public_path__ + "static/media/Prize.85adac7e.webp";